import * as gql from '@shared/types/graphql'

export enum ResponseRemovalMessaging {
  ResponseRemoved = 'Feedback Loop has removed this response.',
  RespondentRemoved = 'This respondent has been removed.',
  Accepted = 'Click here to toggle the response on or off.'
}

export enum ResponseRemovalReason {
  Profanity = 'Profanity',
  Irrelevant = 'Irrelevant',
  Contradictory = 'Contradictory',
  Spam = 'Spam',
  Allowed = 'Allowed',
  Unknown = 'Unknown',
  LowEffort = 'Low Effort',
  IncompleteSession = 'Incomplete Session',
  DefaultAcceptedLength = 'Default Accepted Length',
  PersonalInfo = 'Personal Info'
}

export const RemovalReasonCopyMap: Record<gql.DataQualityCategory, ResponseRemovalReason> = {
  [gql.DataQualityCategory.RestrictedContent]: ResponseRemovalReason.Profanity,
  [gql.DataQualityCategory.Uninformative]: ResponseRemovalReason.Irrelevant,
  [gql.DataQualityCategory.Inconsistent]: ResponseRemovalReason.Contradictory,
  [gql.DataQualityCategory.Gibberish]: ResponseRemovalReason.Spam,
  [gql.DataQualityCategory.Disqualified]: ResponseRemovalReason.LowEffort,
  // The following should not show up on the frontend
  [gql.DataQualityCategory.PersonalInfo]: ResponseRemovalReason.PersonalInfo,
  [gql.DataQualityCategory.IncompleteSession]: ResponseRemovalReason.IncompleteSession,
  [gql.DataQualityCategory.DefaultAcceptedLength]: ResponseRemovalReason.DefaultAcceptedLength,
  [gql.DataQualityCategory.Allowed]: ResponseRemovalReason.Allowed,
  [gql.DataQualityCategory.Unknown]: ResponseRemovalReason.Unknown
}
